export const PRODUCTS = [
  {
    id: 1,
    name: "Apex Top Arm Roller Load Gauge",
    shortName: "Top Arm",
    heroSpec: { num: "5,000+", unit: "Mills", label: "Rely on this instrument worldwide" },
    sub: "Ring Frames & Speed Frames",
    cat: "Measurement",
    image: "/images/top-arm.png",
    desc: "The original Apex instrument. Measures the actual load applied by P 3-1 pneumatic top arms on drafting rollers. Reveals unnoticed load variations that directly cause CV%, imperfection, and end-break problems.",
    specs: [
      "Direct load reading in kg with built-in planometer",
      "Suits all compact spinning systems",
      "Calibration traceable to national & international standards",
      "2-year warranty",
      "Supplied in rugged carrying case",
    ],
    compat: [
      "Rieter, Lakshmi, Toyota, Marzoli, Suessen, Rotorcraft, All Chinese Models",
      "All compact spinning variants",
    ],
    results: [
      "Immediate improvement in count CV%, CSP, and appearance",
      "Reduced imperfections and end breakage rates",
      "Payback often in days",
      "Reduced power consumption & machine wear (1 kg excess front load = 1250 Kg excess load per 1000 spindles)",
      "Used in 5,000+ mills across 18 countries",
    ],
  },
  {
    id: 2,
    name: "Apex Digital Top Arm Load Gauge",
    shortName: "Digital Top Arm",
    heroSpec: { num: "0.1", unit: "kg", label: "Accuracy — no interpolation error" },
    sub: "Ring Frames & Speed Frames — NEW (Launched 2026)",
    cat: "Measurement",
    image: "/images/digital-top-arm.png",
    desc: "Next-generation digital version of our flagship instrument. Simultaneously displays load and angle on a single screen, eliminating interpolation errors and speeding up full-frame audits.",
    specs: [
      "Load + angle on one digital display",
      "0.1 kg accuracy",
      "No interpolation error",
      "For Ring Frames & Speed Frames",
    ],
    compat: [
      "Rieter, Lakshmi, Toyota, Marzoli, Suessen, Rotorcraft, All Chinese Models",
      "All compact spinning variants",
    ],
    results: [
      "Faster full-frame audits",
      "Enhanced accuracy over analog models",
      "Reduced operator reading errors",
    ],
  },
  {
    id: 3,
    name: "Apex Draw Frame Roller Load Gauge",
    shortName: "Draw Frame",
    heroSpec: { num: "18+", unit: "Countries", label: "Exported globally since 1996" },
    sub: "Draw Frames, Comber Draw Boxes & Lap Formers",
    cat: "Measurement",
    image: "/images/draw-frame.png",
    desc: "Measures drafting roller loads on Draw frames, Comber draw boxes, and Lap formers. Ensures consistent sliver evenness across all delivery heads.",
    specs: [
      "Dual dial design, direct kg readings",
      "Planometer included",
      "No special skills required",
      "2-year warranty",
    ],
    compat: [
      "Rieter RSB-D 22, RSB-D 24, RSB-D 26, SB-D 11, D50, D55, E32, E35",
      "Lakshmi LDO 6, LD 2, LDF 3, LRSB, LDB3, LK-54, LK-64, LK-69, LH-10, LH-15, LH-20",
      "Trutzschler TD 03, TD 7, TD 8, TD 10, HSR 1000",
    ],
    results: [
      "Improved downstream yarn U%, CV%, and IPI",
      "Consistent sliver evenness across all delivery heads",
      "Reduction in periodic faults on USTER spectrograms",
      "Used in 5,000+ mills across 18 countries",
    ],
  },
  {
    id: 4,
    name: "Apex Comber Detaching Roller Load Gauge",
    shortName: "Comber",
    heroSpec: { num: "100%", unit: "", label: "Detaching roller specific measurement" },
    sub: "Combers",
    cat: "Measurement",
    image: "/images/comber-detaching.png",
    desc: "Specifically measures detaching roller loads on Combers for optimal combing efficiency and reduced noil waste.",
    specs: [
      "Dual dial design, direct kg readings",
      "Planometer included",
      "Measures detaching roller loads specifically",
    ],
    compat: [
      "Rieter — All models",
      "Lakshmi — All models",
      "Marzoli, Toyota and Chinese models",
    ],
    results: [
      "Improved combing efficiency",
      "Reduced noil waste",
      "Head-to-head consistency in sliver quality",
      "Better nep removal",
    ],
  },
  {
    id: 5,
    name: "Apex Saddle Setting Device",
    shortName: "Saddle Setting",
    heroSpec: { num: "0.1", unit: "mm", label: "Accuracy — 10× better than hand gauges" },
    sub: "P 3-1 Top Arm Drafting",
    cat: "Setting",
    image: "/images/saddle-setting.png",
    desc: "Precision device for setting saddle positions on P 3-1 top arms with 0.1mm accuracy — 10x better than hand gauges, in 1/10th the time.",
    specs: [
      "0.1mm accuracy (10× better than hand gauges)",
      "Team of 2 in 2 hours (vs traditional team of 5 in 8 hours)",
      "Machine doesn't need to stop during setting",
      "Slip-on fitting — no finger injuries",
      "Front + back zone vernier scales",
      "Portable, rolls into spinning shop",
    ],
    compat: [
      "All P 3-1 top arms",
      "All Lakshmi, Rieter ring frames",
    ],
    results: [
      "10× more accurate than hand gauges",
      "1/10th the time of traditional methods",
      "No finger injuries",
      "Improved spindle-to-spindle consistency",
    ],
  },
  {
    id: 6,
    name: "Apex Ring Spindle Concentricity Setting Device",
    shortName: "Spindle Concentricity",
    heroSpec: { num: "<20", unit: "sec", label: "Per spindle — stationary, no stoppage" },
    sub: "Ring Frames",
    cat: "Setting",
    image: "/images/spindle-centering.png",
    desc: "World's first device to check and set ring-spindle concentricity on stationary spindles. Reduces hairiness caused by eccentricity. Sets concentricity in one spindle in less than 20 seconds. Self-centering device requiring no operator participation in centering. No eye fatigue or parallax error — the operator just loosens and tightens the screws.",
    specs: [
      "±0.1mm accuracy — self-centering, no skill needed",
      "Less than 20 seconds per spindle (vs ½ min nylon / 5 min electronic)",
      "Works on stationary spindles (Apex invention)",
      "Ring traveller never needs removal",
      "One device life: ~1 lakh spindles",
      "Centering at multiple levels with long measuring surface",
      "Available for all ring diameters, all spindle tapers",
    ],
    compat: [
      "All ring frame manufacturers",
      "All ring diameters (36mm to 54mm)",
      "Proven on Rieter, Lakshmi, Toyota, Marzoli",
    ],
    results: [
      "Reduces hairiness increase from eccentricity",
      "Significant reduction in end breaks",
      "Improved spindle utilisation towards 98% standard",
      "Extended spindle and ring life",
      "Full-frame audits now feasible",
    ],
  },
  {
    id: 7,
    name: "Apex Fluted Roller Eccentricity Checking Device",
    shortName: "Fluted Roller",
    heroSpec: { num: "0", unit: "Stops", label: "Machine runs during measurement" },
    sub: "Ring Frames & Speed Frames",
    cat: "Measurement",
    image: "/images/fluted-roller.png",
    desc: "Quick and easy method to find peak and low eccentricity in fluted drafting rollers while the machine is running. Identifies the root cause of mysterious periodic faults caused by peaks and lows.",
    specs: [
      "Top-facing dial for direct reading",
      "Quick and easy placement",
      "Finds peak & low in drafting",
      "Machine need not be stopped — readings taken while production is on and Top Arm is pressed",
      "No special skills required",
    ],
    compat: [
      "All ring frames and speed frames",
      "All fluted bottom rollers",
    ],
    results: [
      "Identifies root cause of mysterious periodic faults",
      "Data-driven bottom roller corrections enabled",
      "Reduced imperfection index",
      "Preventive maintenance capability",
    ],
  },
  {
    id: 8,
    name: "Apex Dew Point Indicator",
    shortName: "Dew Point",
    heroSpec: { num: "500", unit: "g", label: "Ultra-compact — India's first indigenous device" },
    sub: "Compressed Air Systems",
    cat: "Measurement",
    image: "/images/dew-point.png",
    desc: "Air drying efficiency drops whenever air dryers are undersized or malfunctioning. The first indicator of undried or partially dried air is an increase of the dew point. Normal dew point for a refrigerated air dryer is 4°C and -40°C for a desiccant (heatless) air dryer. Increased dew points are a disaster for sensitive pneumatic valves, cylinders and connectors. Our portable, digital, chargeable dew point indicator provides early detection of air dryer failure, protecting costly pneumatic equipment.",
    specs: [
      "Instant digital dew point readout",
      "Compact: under 500 grams",
      "Chargeable and portable",
      "Affordable",
      "World class dew point indicator — made completely in India for the first time",
    ],
    compat: [
      "All compressed air dryer systems",
      "Industrial refrigerant & desiccant dryers",
    ],
    results: [
      "Early detection of air dryer failure",
      "Protection of costly pneumatic equipment — keeps your machinery and process better",
      "Consistent top arm loading performance",
      "Replaces assumption with measurement",
    ],
  },
  {
    id: 9,
    name: "Prasiddhi — Simple Compact Spinning Attachment",
    shortName: "Prasiddhi",
    heroSpec: { num: "12", unit: "mm", label: "Shortest condensing zone on the market" },
    sub: "Retrofit for Existing Ring Frames — NEW (Launched 2026)",
    cat: "Enhancement",
    image: "/images/compact.png",
    desc: "Revolutionary retrofit attachment that brings compact yarn quality to existing ring frames. Features the shortest condensing zone in the market (12mm). Catches even short fibers and integrates them into the yarn bundle adding to strength — implying scope for reducing twist thereby increasing production. Uses existing suction, no new drafting changes, all counts and fibres. Simple conversion, cost effective — world's most economic compact spinning system.",
    specs: [
      "Uses existing suction — no new source needed",
      "No change in drafting",
      "Friction-free tubular suction tube",
      "Optional all top apron drive for front and back rollers",
      "Innovative apron shifter for maximum service life",
      "All counts, all fibres",
    ],
    compat: [
      "Lakshmi ring frames (LR series)",
      "Rieter ring frames (G series)",
      "Toyota ring frames (RX series)",
      "Most ring frames with standard drafting",
    ],
    results: [
      "Compact yarn quality from existing frames",
      "No huge capex on suction or drafting",
      "Higher yarn selling price (compact premium)",
      "Quick retrofit, minimal downtime",
      "Reduced hairiness → fewer warp breaks",
    ],
  },
];

export const CATEGORIES = ["All", "Measurement", "Setting", "Enhancement"];
